(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wa-goal-popup"] && !Shopify.designMode) return;
  try {
    // WA:START - multi-popups v3.1 (contrôleur global renforcé)
  (function () {
    if (customElements.get('wa-goal-popup')) return;

    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    var OPEN_DELAY = 300;           // délai avant ouverture auto (laisse le tiroir s'ouvrir)
    var BETWEEN_POPUPS = 300;       // pause entre la fermeture d'une popup et l'ouverture de la suivante
    var PENDING_WINDOW = 6000;      // durée pendant laquelle un franchissement cherche ses blocs
    var HOST_MISSING_TTL = 8000;    // abandon d'une ouverture si le bloc reste introuvable
    var ADOPT_WINDOW = 400;         // délai de ré-adoption d'un dialog lors d'un remontage
    var COVER_CHECK_AFTER = 800;    // vérif « popup recouverte » après ouverture
    var MAX_RESTACK = 3;            // nb max de remises au premier plan par ouverture
    var TICK = 200;                 // cadence du superviseur
    var INTERACTION_TTL = 10000;    // durée de validité d'un clic dans une popup
    var STATE_KEY = 'waGoalState';  // dernier panier connu { t, c, items }
    var GIFTS_KEY = 'waGoalGifts';  // cadeaux suivis { goalKey: { key, v, added, label } }

    /* ------- Utilitaires ------- */
    function selEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(String(s)) : String(s); }
    function ssGet(k) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
    function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

    function readGifts() { return ssGet(GIFTS_KEY) || {}; }
    function writeGifts(g) { ssSet(GIFTS_KEY, g); }

    function toState(cart) {
      var items = {};
      ((cart && cart.items) || []).forEach(function (it) {
        items[it.key] = { q: it.quantity, v: String(it.variant_id), p: it.final_line_price || 0 };
      });
      return { t: (cart && cart.total_price) || 0, c: (cart && cart.item_count) || 0, items: items };
    }

    function qtyByVariant(state) {
      var out = {};
      Object.keys((state && state.items) || {}).forEach(function (k) {
        var it = state.items[k];
        out[it.v] = (out[it.v] || 0) + it.q;
      });
      return out;
    }

    function findHost(key) {
      try { return document.querySelector('wa-goal-popup[data-goal-key="' + selEsc(key) + '"]'); } catch (e) { return null; }
    }
    function allHosts() {
      var seen = {}, out = [];
      document.querySelectorAll('wa-goal-popup[data-goal-key]').forEach(function (h) {
        var k = h.dataset.goalKey;
        if (!seen[k]) { seen[k] = true; out.push(h); }
      });
      return out;
    }
    // WA:START - masquage cartes produit vides
    var HIDDEN_CLASS = 'wa-goal-popup__hidden';

    // Carte sans produit (placeholder / id vide) ou rendu en « Liquid error ».
    function isBrokenCard(card) {
      var pc = card.matches('product-card') ? card : card.querySelector('product-card');
      if (card.getAttribute('data-placeholder') === 'true') return true;
      if (!pc) return true;
      if (pc.getAttribute('data-placeholder') === 'true' || !pc.getAttribute('data-product-id')) return true;
      return /Liquid error/i.test(card.textContent || '');
    }

    // Masque les cartes cassées, puis leur groupe parent si toutes ses cartes
    // le sont. Le groupe racine de la popup n'est jamais masqué.
    function hideBrokenCards(d) {
      if (!d) return;
      d.querySelectorAll('.' + HIDDEN_CLASS).forEach(function (el) { el.classList.remove(HIDDEN_CLASS); });

      var cards = [];
      d.querySelectorAll('product-card-link, product-card').forEach(function (el) {
        if (el.matches('product-card') && el.closest('product-card-link')) return;
        cards.push(el);
      });

      var groups = [];
      cards.forEach(function (card) {
        if (!isBrokenCard(card)) return;
        card.classList.add(HIDDEN_CLASS);
        var group = card.parentElement && card.parentElement.closest('.group-block');
        if (!group || !d.contains(group) || groups.indexOf(group) !== -1) return;
        var outer = group.parentElement && group.parentElement.closest('.group-block');
        if (!outer || !d.contains(outer)) return;
        groups.push(group);
      });

      groups.forEach(function (group) {
        var allBroken = cards.every(function (card) {
          return !group.contains(card) || card.classList.contains(HIDDEN_CLASS);
        });
        if (allBroken) group.classList.add(HIDDEN_CLASS);
      });
    }
    // WA:END - masquage cartes produit vides

    function portaledDialog(key) {
      try { return document.body.querySelector(':scope > dialog[data-wa-owner="' + selEsc(key) + '"]'); } catch (e) { return null; }
    }

    /* =====================================================================
       FILE D'OUVERTURE
       Une entrée reste dans la file tant que sa popup n'est pas RÉELLEMENT
       ouverte : un bloc momentanément absent (re-render du tiroir) ne fait
       plus perdre l'ouverture, elle est retentée à chaque tick.
       ===================================================================== */
    var toOpen = [];            // [{ k, g, prio, change, missingSince }]
    var activeKey = null;       // popup actuellement ouverte
    var activeSince = 0;
    var restacks = 0;
    var nextOpenAt = 0;
    var lastInteraction = null; // { key, at } : dernier clic dans une popup

    // prio : passe devant les autres ; change : réouverture via « changer mon cadeau »
    // (ignore les contrôles cadeau déjà choisi / objectif atteint).
    function addToOpen(k, g, prio, change) {
      if (!k || k === activeKey) return;
      for (var i = 0; i < toOpen.length; i++) {
        if (toOpen[i].k === k) {
          if (prio) toOpen[i].prio = true;
          if (change) toOpen[i].change = true;
          ensureTick();
          return;
        }
      }
      toOpen.push({ k: k, g: g || 0, prio: !!prio, change: !!change, missingSince: 0 });
      ensureTick();
    }

    function pump() {
      if (activeKey || Date.now() < nextOpenAt || !toOpen.length) return;

      // Une popup ouverte non suivie (ré-adoption, etc.) devient la popup active.
      var stray = document.body.querySelector(':scope > dialog[data-wa-owner][open]');
      if (stray) {
        if (!stray.__waClosing) { activeKey = stray.getAttribute('data-wa-owner'); activeSince = Date.now(); restacks = 0; }
        return;
      }

      var st = ssGet(STATE_KEY);
      var gifts = readGifts();
      var now = Date.now();

      // Purge : cadeau déjà choisi, objectif plus atteint (sauf « changer »), bloc introuvable trop longtemps.
      toOpen = toOpen.filter(function (e) {
        if (!e.change && gifts[e.k]) return false;
        if (!e.change && st && e.g && st.t < e.g) return false;
        if (e.missingSince && now - e.missingSince > HOST_MISSING_TTL) return false;
        return true;
      });

      // Priorité aux « changer mon cadeau », puis objectif croissant.
      toOpen.sort(function (a, b) { return (b.prio - a.prio) || (a.g - b.g); });

      for (var i = 0; i < toOpen.length; i++) {
        var e = toOpen[i];
        var host = findHost(e.k);
        var d = host ? host.resolveDialog() : null;
        if (!d) { if (!e.missingSince) e.missingSince = now; continue; }
        e.missingSince = 0;

        host.open(d);
        if (d.open) {
          toOpen.splice(i, 1);
          activeKey = e.k;
          activeSince = now;
          restacks = 0;
          return;
        }
      }
    }

    // Surveille la popup active : disparue sans fermeture -> remise en file ;
    // recouverte (ex. tiroir ouvert par-dessus) -> remise au premier plan.
    function watchActive() {
      if (!activeKey) return;
      var d = portaledDialog(activeKey);

      if (!d || !d.open) {
        var k = activeKey;
        activeKey = null;
        addToOpen(k, hostGoal(k), true);
        return;
      }

      if (d.__waClosing || restacks >= MAX_RESTACK) return;

      // WA:START - ne pas recouvrir la modale d'ajout rapide
      // Ouverte volontairement par le client depuis la popup (produit à
      // variantes) : la repasser derrière la rendrait inutilisable.
      if (document.querySelector('quick-add-dialog dialog[open]')) return;
      // WA:END - ne pas recouvrir la modale d'ajout rapide
      if (Date.now() - activeSince < COVER_CHECK_AFTER) return;

      var r = d.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = r.left + r.width / 2;
      var y = r.top + Math.min(r.height / 2, 40);
      if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) return;
      var hit = document.elementFromPoint(x, y);
      if (hit && !d.contains(hit)) {
        restacks++;
        activeSince = Date.now();
        try { d.close(); d.showModal(); } catch (err) {}
      }
    }

    function hostGoal(k) {
      var h = findHost(k);
      return h ? (parseInt(h.dataset.goal, 10) || 0) : 0;
    }

    // Fermeture volontaire (choix du cadeau, croix, fond, Échap).
    function onPopupClosed(key) {
      if (activeKey === key) activeKey = null;
      if (lastInteraction && Date.now() - lastInteraction.at > 2000) lastInteraction = null;
      nextOpenAt = Date.now() + BETWEEN_POPUPS;
      ensureTick();
    }

    /* ------- Superviseur : tourne tant qu'il reste quelque chose à faire ------- */
    var tickTimer = null;
    function ensureTick() {
      if (inEditor || tickTimer) return;
      tickTimer = setInterval(tick, TICK);
    }
    function tick() {
      processPending();
      watchActive();
      pump();
      syncReminders(); // WA - rappel « choisir mon cadeau »
      if (!pending && !toOpen.length && !activeKey) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
    }

    /* =====================================================================
       SYNCHRONISATION AVEC /cart.js (source de vérité)
       ===================================================================== */
    // WA:START - synchro rapide et horodatée
    var syncTimer = null, syncBusy = false, syncAgain = false, retryTimer = null;
    var lastAppliedAt = 0; // début de la requête dont le résultat est affiché/mémorisé
    var stateAt = 0;       // idem, pour l'état connu

    // Options des requêtes internes (exclues du suivi d'activité du thème).
    function internal(init) { init = init || {}; init.waInternal = true; return init; }

    function scheduleSync() {
      if (inEditor) return;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () { runSync(false); }, 40);
    }

    function runSync(silent) {
      if (syncBusy) { syncAgain = true; return; }
      syncBusy = true;
      var startedAt = Date.now();
      fetch('/cart.js', internal({ headers: { 'Accept': 'application/json' }, cache: 'no-store' }))
        .then(function (r) { if (!r.ok) throw new Error('cart.js'); return r.json(); })
        .then(function (cart) { applyCart(cart, silent, startedAt); })
        .catch(function () {
          // Échec réseau : on retente, sinon le franchissement serait perdu.
          clearTimeout(retryTimer);
          retryTimer = setTimeout(function () { runSync(silent); }, 500);
        })
        .then(function () {
          syncBusy = false;
          if (syncAgain) { syncAgain = false; runSync(false); }
        });
    }

    function isCartJson(c) {
      return !!(c && Array.isArray(c.items) && typeof c.total_price === 'number' && typeof c.item_count === 'number');
    }

    // silent = chargement de page : on mémorise l'état sans rien ouvrir.
    // startedAt : une réponse plus ANCIENNE que la dernière appliquée est ignorée.
    function applyCart(cart, silent, startedAt) {
      if (!isCartJson(cart)) return;
      startedAt = startedAt || Date.now();
      if (startedAt < lastAppliedAt) return;
      lastAppliedAt = startedAt;
      stateAt = startedAt;

      var prev = ssGet(STATE_KEY);
      var next = toState(cart);
      ssSet(STATE_KEY, next);
      if (!silent && prev) {
        if (next.c > prev.c) captureGift(prev, next);
        if (next.t > prev.t) addPending(prev.t, next.t);
      }
      pruneGifts(next);
      enforceGoals(next);
      syncLinksSoon();
    }

    // Mémorise un panier issu d'une opération du bloc (sans détection).
    function commitCart(cart, startedAt) {
      if (!isCartJson(cart)) return;
      if (startedAt >= lastAppliedAt) { lastAppliedAt = startedAt; stateAt = startedAt; }
      ssSet(STATE_KEY, toState(cart));
    }

    // Opérations panier du bloc : une à la fois.
    var cartOpChain = Promise.resolve();
    function queueCartOp(fn) {
      var run = cartOpChain.then(fn, fn);
      cartOpChain = run.catch(function () {});
      return run;
    }
    // WA:END - synchro rapide et horodatée

    // Article ajouté pendant qu'une popup est active -> c'est le cadeau de CETTE popup.
    function captureGift(prev, next) {
      var owner = activeKey;
      if (!owner && lastInteraction && Date.now() - lastInteraction.at < INTERACTION_TTL) owner = lastInteraction.key;
      if (!owner) return;
      lastInteraction = null;

      var host = findHost(owner);
      var inPopup = host ? host.dialogVariantIds() : {};

      // Variantes dont la quantité totale a augmenté (et non les clés, qui peuvent changer).
      var prevV = qtyByVariant(prev), nextV = qtyByVariant(next);
      var added = [];
      Object.keys(nextV).forEach(function (v) {
        var diff = nextV[v] - (prevV[v] || 0);
        if (diff > 0) added.push({ v: v, added: diff });
      });
      if (!added.length) return;
      added.sort(function (a, b) { return (inPopup[b.v] ? 1 : 0) - (inPopup[a.v] ? 1 : 0); });
      var pick = added[0];

      // Ligne de cette variante : de préférence une ligne nouvelle.
      var key = null;
      Object.keys(next.items).forEach(function (k) {
        if (next.items[k].v !== pick.v) return;
        if (!key || !(prev.items && prev.items[k])) key = k;
      });
      if (!key) return;

      var gifts = readGifts();
      gifts[owner] = {
        key: key,
        v: pick.v,
        added: pick.added,
        label: (host && host.dataset.changeLabel) || 'Changer mon cadeau',
        goal: host ? (parseInt(host.dataset.goal, 10) || 0) : 0 // WA - retrait cadeaux inéligibles
      };
      writeGifts(gifts);

      // Fermer la popup, qu'elle soit portée par l'instance courante ou non.
      if (host) host.requestClose();
      else closeOrphan(owner);
    }

    function closeOrphan(key) {
      var d = portaledDialog(key);
      if (d) { try { d.close(); } catch (e) {} d.remove(); }
      onPopupClosed(key);
    }

    // Recale chaque cadeau sur le panier réel : clé mise à jour si Shopify l'a
    // régénérée, suivi abandonné seulement si la variante n'est plus au panier.
    function pruneGifts(state) {
      var gifts = readGifts(), changed = false;
      var vQty = qtyByVariant(state);
      var usedKeys = {};

      Object.keys(gifts).forEach(function (o) {
        var g = gifts[o];
        if (!g || !g.key) { delete gifts[o]; changed = true; return; }

        var line = state.items[g.key];
        if (!g.v) {
          if (!line) { delete gifts[o]; changed = true; return; }
          g.v = line.v; changed = true;
        }

        if ((vQty[g.v] || 0) < (g.added || 1)) { delete gifts[o]; changed = true; return; }

        if (!line || line.v !== g.v) {
          var found = null;
          Object.keys(state.items).forEach(function (k) {
            if (state.items[k].v !== g.v) return;
            if (!found || (usedKeys[found] && !usedKeys[k])) found = k;
          });
          if (!found) { delete gifts[o]; changed = true; return; }
          g.key = found; changed = true;
        }
        usedKeys[g.key] = true;
      });

      if (changed) writeGifts(gifts);
    }

    /* =====================================================================
       FRANCHISSEMENTS DE SEUIL
       Le franchissement reste actif PENDING_WINDOW ms : chaque tick relit les
       blocs présents, donc un bloc rendu en retard est quand même pris en
       compte (et plus seulement ceux présents à un instant T).
       ===================================================================== */
    var pending = null; // { from, to, at, seen }

    function addPending(from, to) {
      if (pending) {
        pending.from = Math.min(pending.from, from);
        pending.to = Math.max(pending.to, to);
        pending.at = Date.now(); // prolonge la fenêtre
      } else {
        pending = { from: from, to: to, at: Date.now(), seen: {} };
      }
      ensureTick();
    }

    function processPending() {
      if (!pending) return;
      var elapsed = Date.now() - pending.at;
      if (elapsed < OPEN_DELAY) return;

      var st = ssGet(STATE_KEY) || { t: 0 };
      var gifts = readGifts();
      allHosts().forEach(function (h) {
        var g = parseInt(h.dataset.goal, 10) || 0;
        var k = h.dataset.goalKey;
        if (pending.seen[k]) return;
        if (g > 0 && g > pending.from && g <= pending.to && st.t >= g && !gifts[k]) {
          pending.seen[k] = true;
          addToOpen(k, g, false);
        }
      });

      if (elapsed > PENDING_WINDOW) pending = null;
    }

    /* =====================================================================
       LIENS « CHANGER MON CADEAU » : un par cadeau, sous le sélecteur
       ===================================================================== */
    function linkTarget(row) {
      return row.querySelector('.cart-items__quantity') || row.querySelector('.cart-items__details') || row;
    }

    function syncLinks() {
      if (inEditor) return;
      var gifts = readGifts();

      document.querySelectorAll('[data-wa-gift-change]').forEach(function (el) {
        var o = el.getAttribute('data-wa-injected');
        var g = gifts[o];
        var row = el.closest('.cart-items__table-row[data-key]');
        if (!g || !row || row.dataset.key !== g.key || !findHost(o)) { el.remove(); return; }

        var target = linkTarget(row);
        var next = el.nextElementSibling;
        while (next && next.hasAttribute('data-wa-gift-change')) next = next.nextElementSibling;
        if (el.parentNode !== target || next) target.appendChild(el);
      });

      var rows = document.querySelectorAll('.cart-items__table-row[data-key]');
      Object.keys(gifts).forEach(function (o) {
        var g = gifts[o];
        if (!g || !findHost(o)) return;
        rows.forEach(function (row) {
          if (row.dataset.key !== g.key) return;
          if (row.querySelector('[data-wa-gift-change][data-wa-injected="' + selEsc(o) + '"]')) return;

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'wa-gift-change-link';
          btn.setAttribute('data-wa-gift-change', '');
          btn.setAttribute('data-wa-injected', o);
          btn.textContent = g.label || 'Changer mon cadeau';
          btn.addEventListener('click', function () { changeGift(o, btn); });
          linkTarget(row).appendChild(btn);
        });
      });

      syncReminders(); // WA - rappel « choisir mon cadeau »
    }

    var linkTimers = [];
    function syncLinksSoon() {
      if (inEditor) return;
      linkTimers.forEach(clearTimeout);
      linkTimers = [0, 200, 600, 1200, 2500].map(function (ms) { return setTimeout(syncLinks, ms); });
    }

    // WA:START - rappel « choisir mon cadeau »
    /* =====================================================================
       RAPPEL « CHOISIR MON CADEAU »
       Objectif atteint mais aucun cadeau pris (popup fermée sans choix, page
       rechargée, retour sur le site) : une ligne cliquable reste affichée à
       l'emplacement du bloc et rouvre SA popup. Elle disparaît dès que le
       cadeau est choisi, ou si l'objectif n'est plus atteint.
       ===================================================================== */
    function syncReminders() {
      if (inEditor) return;
      var st = ssGet(STATE_KEY);
      var gifts = readGifts();
      // Même base de calcul que le retrait des cadeaux inéligibles : le total
      // panier HORS cadeaux suivis.
      var eligible = st ? eligibleTotal(st, gifts) : 0;

      document.querySelectorAll('[data-wa-goal-reminder]').forEach(function (el) {
        var host = el.closest('wa-goal-popup[data-goal-key]');
        if (!host) { el.hidden = true; return; }

        var key = host.dataset.goalKey;
        var goal = parseInt(host.dataset.goal, 10) || 0;
        // Popup déjà ouverte ou sur le point de s'ouvrir : pas de rappel.
        var queued = toOpen.some(function (e) { return e.k === key; });

        el.hidden = !(st && goal > 0 && eligible >= goal && !gifts[key] && activeKey !== key && !queued);
      });
    }

    // Délégation : la ligne est re-rendue avec le tiroir à chaque maj du panier.
    if (!inEditor) {
      document.addEventListener('click', function (ev) {
        var btn = (ev.target && ev.target.closest) ? ev.target.closest('[data-wa-goal-reminder]') : null;
        if (!btn) return;
        var host = btn.closest('wa-goal-popup[data-goal-key]');
        if (!host) return;
        ev.preventDefault();
        nextOpenAt = 0;
        addToOpen(host.dataset.goalKey, parseInt(host.dataset.goal, 10) || 0, true, true);
        syncReminders();
      });
    }
    // WA:END - rappel « choisir mon cadeau »

    // WA:START - retrait cadeaux inéligibles
    /* =====================================================================
       RETRAIT DES CADEAUX DONT L'OBJECTIF N'EST PLUS ATTEINT
       ===================================================================== */
    var enforcing = false;

    // WA:START - rendu panier direct
    function drawerSection() {
      var inner = document.querySelector('.cart-drawer__inner');
      var el = inner ? inner.closest('[id^="shopify-section-"]') : null;
      return { el: el, id: el ? el.id.replace('shopify-section-', '') : null };
    }

    // Icône panier du header (hors tiroir), avec le sélecteur qui l'a trouvée.
    var CART_ICON_SELECTORS = [
      'cart-icon',
      '.header-actions__cart-icon',
      '[data-testid="cart-icon"]',
      'a[href$="/cart"]'
    ];
    function findCartIcon(root) {
      for (var i = 0; i < CART_ICON_SELECTORS.length; i++) {
        var list = root.querySelectorAll(CART_ICON_SELECTORS[i]);
        for (var j = 0; j < list.length; j++) {
          if (!list[j].closest('#cart-drawer')) return { el: list[j], selector: CART_ICON_SELECTORS[i] };
        }
      }
      return null;
    }
    function headerSection() {
      var icon = findCartIcon(document);
      var el = icon ? icon.el.closest('[id^="shopify-section-"]') : null;
      return { el: el, id: el ? el.id.replace('shopify-section-', '') : null, icon: icon };
    }

    // WA:START - synchro attributs icône panier
    // Aligne tous les attributs de target sur ceux de source.
    function syncAttributes(target, source) {
      Array.prototype.slice.call(target.attributes).forEach(function (a) {
        if (!source.hasAttribute(a.name)) target.removeAttribute(a.name);
      });
      Array.prototype.slice.call(source.attributes).forEach(function (a) {
        if (target.getAttribute(a.name) !== a.value) target.setAttribute(a.name, a.value);
      });
    }

    // Parents de l'icône (3 niveaux, dans la section header) : seuls les
    // classes et data-* liés au panier sont alignés, pour ne pas toucher aux
    // états propres au header (sticky, menu ouvert…).
    function syncCartAncestors(target, source, boundary) {
      var t = target.parentElement, f = source.parentElement;
      for (var i = 0; i < 3 && t && f && t !== boundary && t.tagName === f.tagName; i++) {
        var isCart = function (n) { return /cart|bubble|count/i.test(n); };
        Array.prototype.slice.call(t.classList).forEach(function (c) {
          if (isCart(c) && !f.classList.contains(c)) t.classList.remove(c);
        });
        Array.prototype.slice.call(f.classList).forEach(function (c) {
          if (isCart(c)) t.classList.add(c);
        });
        Array.prototype.slice.call(t.attributes).forEach(function (a) {
          if (/^data-/.test(a.name) && isCart(a.name) && !f.hasAttribute(a.name)) t.removeAttribute(a.name);
        });
        Array.prototype.slice.call(f.attributes).forEach(function (a) {
          if (/^data-/.test(a.name) && isCart(a.name)) t.setAttribute(a.name, a.value);
        });
        t = t.parentElement; f = f.parentElement;
      }
    }
    // WA:END - synchro attributs icône panier

    function renderSectionIds() {
      var ids = [];
      var d = drawerSection(), h = headerSection();
      if (d.id) ids.push(d.id);
      if (h.id && ids.indexOf(h.id) === -1) ids.push(h.id);
      return ids;
    }

    // Applique le HTML frais : intérieur du tiroir + icône panier du header.
    function renderCartUI(sections, cart) {
      if (!sections) return;

      var d = drawerSection();
      var dHtml = d.id ? sections[d.id] : null;
      if (dHtml && d.el) {
        var dDoc = new DOMParser().parseFromString(dHtml, 'text/html');
        var freshInner = dDoc.querySelector('.cart-drawer__inner');
        var currentInner = d.el.querySelector('.cart-drawer__inner');
        if (freshInner && currentInner) currentInner.replaceWith(freshInner);
      }

      var h = headerSection();
      var hHtml = h.id ? sections[h.id] : null;
      if (hHtml && h.icon) {
        var hDoc = new DOMParser().parseFromString(hHtml, 'text/html');
        var freshIcon = findCartIcon(hDoc);
        if (freshIcon) {
          // WA:START - synchro attributs icône panier
          syncAttributes(h.icon.el, freshIcon.el);
          syncCartAncestors(h.icon.el, freshIcon.el, h.el);
          // WA:END - synchro attributs icône panier
          h.icon.el.innerHTML = freshIcon.el.innerHTML;
        }
      }

      storeThemeCartCount(cart);
      syncLinksSoon();
    }

    // Compteur panier mémorisé par le thème en session (restauré à la page suivante).
    function storeThemeCartCount(cart) {
      if (!cart) return;
      try {
        var raw = sessionStorage.getItem('cart-count');
        if (raw == null) return;
        var parsed = null;
        try { parsed = JSON.parse(raw); } catch (e) { parsed = null; }
        if (parsed && typeof parsed === 'object') {
          if ('value' in parsed) parsed.value = cart.item_count;
          if ('count' in parsed) parsed.count = cart.item_count;
          if ('timestamp' in parsed) parsed.timestamp = Date.now();
          sessionStorage.setItem('cart-count', JSON.stringify(parsed));
        } else {
          sessionStorage.setItem('cart-count', String(cart.item_count));
        }
      } catch (e) {}
    }

    // Activité panier du thème (requêtes internes exclues).
    var themeReqActive = 0;   // requêtes du thème en cours
    var themeReqStartAt = 0;  // début de la dernière requête du thème
    var themeReqEndAt = 0;    // fin de la dernière requête du thème
    var themeEventAt = 0;     // dernier cart:update reçu

    // Le thème a fini : plus de requête + son événement reçu (ou 300 ms de repli).
    function themeSettled() {
      if (themeReqActive > 0) return false;
      var now = Date.now();
      if (themeEventAt >= themeReqEndAt) return now - themeEventAt >= 60;
      return now - themeReqEndAt >= 300;
    }
    function waitThemeQuiet(maxWait) {
      var start = Date.now();
      return new Promise(function (resolve) {
        (function check() {
          if (themeSettled() || Date.now() - start > maxWait) return resolve();
          setTimeout(check, 30);
        })();
      });
    }

    // Le panier affiché (tiroir + bulle) correspond-il au panier réel ?
    function uiMatches(cart) {
      var items = (cart && cart.items) || [];
      var inner = document.querySelector('.cart-drawer__inner');
      if (inner) {
        var keys = {};
        items.forEach(function (it) { keys[it.key] = true; });
        var rows = inner.querySelectorAll('.cart-items__table-row[data-key]');
        if (rows.length !== items.length) return false;
        for (var i = 0; i < rows.length; i++) { if (!keys[rows[i].dataset.key]) return false; }
        var badge = inner.querySelector('.theme-drawer__badge');
        if (badge && items.length && String(parseInt(badge.textContent, 10) || 0) !== String(cart.item_count)) return false;
      }
      var icon = findCartIcon(document);
      if (icon) {
        var nums = (icon.el.textContent || '').match(/\d+/g);
        if (nums && nums.indexOf(String(cart.item_count)) === -1) return false;
      }
      return true;
    }

    // Vérifie l'affichage après coup ; re-rendu si écart (2 tentatives max).
    function ensureUIFresh(attempt) {
      attempt = attempt || 0;
      if (attempt >= 2) return;
      setTimeout(function () {
        fetch('/cart.js', internal({ headers: { 'Accept': 'application/json' }, cache: 'no-store' }))
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!themeSettled()) { ensureUIFresh(attempt); return; } // le thème rend encore
            if (uiMatches(cart)) return;
            var ids = renderSectionIds();
            if (!ids.length) return;
            return fetchSections(ids).then(function (sections) {
              renderCartUI(sections, cart);
              ensureUIFresh(attempt + 1);
            });
          })
          .catch(function () {});
      }, 400);
    }

    function fetchSections(ids) {
      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')),
        internal({ headers: { 'Accept': 'application/json' }, cache: 'no-store' }))
        .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); });
    }

    // Animation de retrait rapide (220 ms) des lignes qui disparaissent.
    function animateRowsOut(keys) {
      var rows = [];
      document.querySelectorAll('.cart-items__table-row[data-key]').forEach(function (row) {
        if (!keys[row.dataset.key]) return;
        row.style.setProperty('--wa-row-h', row.offsetHeight + 'px');
        row.classList.add('wa-gift-row-out');
        rows.push(row);
      });
      var done = new Promise(function (resolve) {
        if (!rows.length) return resolve();
        setTimeout(resolve, 240);
      });
      return { rows: rows, done: done };
    }

    // Anti-boucle : 3 tentatives max par ligne sur 10 s.
    var removalLog = {};
    function allowRemoval(keys) {
      var now = Date.now(), ok = true;
      keys.forEach(function (k) {
        removalLog[k] = (removalLog[k] || []).filter(function (t) { return now - t < 10000; });
        if (removalLog[k].length >= 3) ok = false;
      });
      if (ok) keys.forEach(function (k) { removalLog[k].push(now); });
      return ok;
    }

    // Retire des quantités de lignes cadeau ({ key: nouvelleQuantité }) et met l'affichage à jour.
    function removeGiftLines(updates) {
      var keys = Object.keys(updates);
      if (!keys.length) return Promise.resolve(null);
      if (!allowRemoval(keys)) return Promise.reject(new Error('removal loop'));

      var gone = {};
      keys.forEach(function (k) { if (updates[k] <= 0) gone[k] = true; });
      var anim = animateRowsOut(gone);

      var ids = renderSectionIds();
      var body = { updates: updates };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }

      var startedAt = Date.now();
      var req = fetch('/cart/update.js', internal({
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })).then(function (r) { if (!r.ok) throw new Error('cart update'); return r.json(); });

      return Promise.all([req, anim.done])
        .then(function (res) {
          var cart = res[0];
          commitCart(cart, startedAt); // avant le rendu : pas de fausse détection

          // Sections absentes de la réponse -> rechargées aussitôt.
          var sections = cart.sections || {};
          var missing = ids.filter(function (id) { return !sections[id]; });
          var ready = missing.length
            ? fetchSections(missing).then(function (extra) {
                Object.keys(extra || {}).forEach(function (k) { sections[k] = extra[k]; });
              }).catch(function () {})
            : Promise.resolve();

          return ready.then(function () {
            renderCartUI(sections, cart);
            ensureUIFresh(0);
            return cart;
          });
        })
        .catch(function (err) {
          anim.rows.forEach(function (row) { row.classList.remove('wa-gift-row-out'); });
          throw err;
        });
    }
    // WA:END - rendu panier direct

    // Objectif d'un bloc : mémorisé avec le cadeau, sinon lu sur le bloc.
    function giftGoal(owner, g) {
      if (g && g.goal) return g.goal;
      var goal = hostGoal(owner);
      if (goal && g) g.goal = goal;
      return goal;
    }

    // Montant éligible = total panier - part des cadeaux suivis.
    function eligibleTotal(state, gifts) {
      var giftShare = 0;
      Object.keys(gifts).forEach(function (o) {
        var g = gifts[o];
        var line = g && state.items[g.key];
        if (line && line.q > 0) giftShare += Math.round((line.p / line.q) * Math.min(g.added || 1, line.q));
      });
      return Math.max(0, state.t - giftShare);
    }

    // Cadeaux inéligibles -> nouvelles quantités par ligne.
    function computeRemoval(state) {
      var gifts = readGifts();
      var eligible = eligibleTotal(state, gifts);
      var updates = {}, lost = [], dirty = false;
      Object.keys(gifts).forEach(function (o) {
        var g = gifts[o];
        var hadGoal = !!g.goal;
        var goal = giftGoal(o, g);
        if (goal && !hadGoal) dirty = true;
        if (!goal || eligible >= goal) return;
        var line = state.items[g.key];
        if (!line) return;
        var base = (g.key in updates) ? updates[g.key] : line.q;
        updates[g.key] = Math.max(0, base - (g.added || 1));
        lost.push(o);
      });
      if (dirty) writeGifts(gifts); // objectifs complétés pour les anciens cadeaux
      return { eligible: eligible, updates: updates, lost: lost };
    }

    function enforceGoals(state) {
      if (inEditor || !state) return;

      var plan = computeRemoval(state);
      var gifts = readGifts();

      // Popups en attente / ouverte dont l'objectif n'est plus atteint.
      toOpen = toOpen.filter(function (e) { return e.change || !e.g || plan.eligible >= e.g; });
      if (activeKey && !gifts[activeKey]) {
        var ag = hostGoal(activeKey);
        if (ag && plan.eligible < ag) {
          var ah = findHost(activeKey);
          if (ah) ah.requestClose(); else closeOrphan(activeKey);
        }
      }

      if (enforcing || !plan.lost.length) return;
      enforcing = true;

      queueCartOp(function () {
        // 1. Laisser le thème terminer sa propre mise à jour (sinon il écrase la nôtre).
        return waitThemeQuiet(1500)
          // 2. Relire le panier seulement si le thème l'a modifié depuis l'état connu.
          .then(function () {
            if (stateAt >= themeReqStartAt && ssGet(STATE_KEY)) return ssGet(STATE_KEY);
            var startedAt = Date.now();
            return fetch('/cart.js', internal({ headers: { 'Accept': 'application/json' }, cache: 'no-store' }))
              .then(function (r) { if (!r.ok) throw new Error('cart.js'); return r.json(); })
              .then(function (cart) { commitCart(cart, startedAt); return toState(cart); });
          })
          .then(function (fresh) {
            pruneGifts(fresh);
            var finalPlan = computeRemoval(fresh);
            if (!finalPlan.lost.length) return;
            // 3. Retrait + rendu.
            return removeGiftLines(finalPlan.updates).then(function (cart) {
              if (!cart) return;
              var gs = readGifts();
              finalPlan.lost.forEach(function (o) { delete gs[o]; });
              writeGifts(gs);
              pruneGifts(toState(cart));
              syncLinksSoon();
            });
          });
      })
        .catch(function () {})
        .then(function () {
          enforcing = false;
          scheduleSync(); // revérifie l'état final (échec compris)
        });
    }
    // WA:END - retrait cadeaux inéligibles

    /* ------- Changer UN cadeau : retire sa ligne puis rouvre SA popup ------- */
    function changeGift(owner, btn) {
      var host = findHost(owner);
      if (!host) return;

      var st = ssGet(STATE_KEY);
      if (st) pruneGifts(st);
      var gifts = readGifts();
      var g = gifts[owner];
      if (!g) { addToOpen(owner, hostGoal(owner), true, true); return; }

      var cur = (st && st.items && st.items[g.key]) ? st.items[g.key].q : (g.added || 1);

      if (btn) btn.disabled = true;

      var updates = {};
      updates[g.key] = Math.max(0, cur - (g.added || 1));

      queueCartOp(function () { return removeGiftLines(updates); }) // WA - synchro rapide et horodatée
        .then(function (cart) {
          if (!cart) throw new Error('no cart');
          var gs = readGifts();
          delete gs[owner];
          writeGifts(gs);
          pruneGifts(toState(cart));
          syncLinksSoon();
          nextOpenAt = Date.now() + 150;
          addToOpen(owner, hostGoal(owner), true, true);
        })
        .catch(function () { if (btn) btn.disabled = false; });
    }

    /* =====================================================================
       DÉTECTION DES MISES À JOUR DU PANIER (plusieurs sources redondantes)
       ===================================================================== */
    if (!inEditor) {
      var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

      // WA:START - synchro rapide et horodatée
      // 1. Événement du thème Horizon.
      document.addEventListener('cart:update', function () {
        themeEventAt = Date.now();
        scheduleSync();
      });

      function trackThemeRequest() {
        themeReqActive++;
        var startedAt = Date.now();
        themeReqStartAt = startedAt;
        return {
          startedAt: startedAt,
          end: function () {
            themeReqActive = Math.max(0, themeReqActive - 1);
            themeReqEndAt = Date.now();
          }
        };
      }

      // 2. Requêtes panier via fetch (thème ou app) : observées, réponse lue sur un clone.
      if (window.fetch && !window.fetch.__waGoal) {
        var nativeFetch = window.fetch;
        var wrappedFetch = function (input, init) {
          var isInternal = !!(init && init.waInternal);
          var p = nativeFetch.apply(this, arguments);
          if (isInternal) return p;
          try {
            var url = typeof input === 'string' ? input : ((input && input.url) || '');
            if (CART_URL.test(url)) {
              var t = trackThemeRequest();
              p.then(function (res) {
                var copy = null;
                try { copy = res.clone(); } catch (e) {}
                t.end();
                if (!copy || !res.ok) { scheduleSync(); return; }
                copy.json()
                  .then(function (json) {
                    // /cart/change|update|clear renvoient le panier complet ; /cart/add non.
                    if (isCartJson(json)) { clearTimeout(syncTimer); applyCart(json, false, t.startedAt); }
                    else scheduleSync();
                  })
                  .catch(scheduleSync);
              }, function () { t.end(); scheduleSync(); });
            }
          } catch (e) {}
          return p;
        };
        wrappedFetch.__waGoal = true;
        window.fetch = wrappedFetch;
      }

      // 3. Requêtes XHR (apps plus anciennes).
      if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__waGoal) {
        var nativeOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
          try {
            if (CART_URL.test(String(url))) {
              var xhr = this, t;
              xhr.addEventListener('loadstart', function () { t = trackThemeRequest(); });
              xhr.addEventListener('loadend', function () {
                if (t) t.end();
                var json = null;
                try { json = JSON.parse(xhr.responseText); } catch (e) {}
                if (t && xhr.status >= 200 && xhr.status < 300 && isCartJson(json)) applyCart(json, false, t.startedAt);
                else scheduleSync();
              });
            }
          } catch (e) {}
          return nativeOpen.apply(this, arguments);
        };
        XMLHttpRequest.prototype.__waGoal = true;
      }
      // WA:END - synchro rapide et horodatée

      // 4. Retour via le cache navigateur.
      window.addEventListener('pageshow', function (e) { if (e.persisted) runSync(true); });

      // État initial, sans ouverture.
      runSync(true);
    }

    customElements.define('wa-goal-popup', class extends HTMLElement {
      // 5. Attributs mis à jour au morph du tiroir.
      static get observedAttributes() { return ['data-cart', 'data-count']; }

      attributeChangedCallback() {
        if (this.isConnected && !inEditor) scheduleSync();
      }

      connectedCallback() {
        if (inEditor) {
          this.setupEditor();
          this.resolveDialog();
          return;
        }
        this.resolveDialog();
        scheduleSync();
        syncLinksSoon();
        if (pending || toOpen.length) ensureTick();
      }

      disconnectedCallback() {
        const d = this._portaled;
        const key = this._injKey();
        this._portaled = null;
        if (!d || d.parentNode !== document.body) return;
        // Remontage du bloc pendant que la popup est ouverte : laisser la
        // nouvelle instance ré-adopter le dialog.
        setTimeout(() => {
          if (d.__waAdopted) { d.__waAdopted = false; return; }
          if (!d.isConnected || d.parentNode !== document.body) return;
          const wasOpen = d.open && !d.__waClosing;
          try { d.close(); } catch (e) {}
          d.remove();
          if (activeKey === key) activeKey = null;
          // Popup perdue sans que le client l'ait fermée -> on la rouvrira.
          if (wasOpen) addToOpen(key, parseInt(this.dataset.goal, 10) || 0, true);
        }, ADOPT_WINDOW);
      }

      _injKey() { return this.dataset.goalKey || '1'; }

      dialogVariantIds() {
        const out = {};
        const d = this.resolveDialog();
        if (!d) return out;
        d.querySelectorAll('input[name="id"], [data-variant-id]').forEach((el) => {
          const v = el.value || el.getAttribute('data-variant-id');
          if (v) out[String(v)] = true;
        });
        return out;
      }

      /* ------- Éditeur : ouverture pilotée par la sélection du bloc ------- */
      setupEditor() {
        if (this._editorWired) return;
        this._editorWired = true;

        const inside = (t) => t === this || (this._dialog && this._dialog.contains(t));

        document.addEventListener('shopify:block:select', (e) => {
          if (inside(e.target)) {
            clearTimeout(this._closeT);
            const d = this.resolveDialog();
            if (d && !d.open) this.open(d);
          }
        });
        document.addEventListener('shopify:block:deselect', (e) => {
          if (inside(e.target)) {
            this._closeT = setTimeout(() => this.requestClose(), 60);
          }
        });
      }

      /* ------- Résolution / câblage du dialog ------- */
      resolveDialog() {
        let portaled = (this._portaled && this._portaled.isConnected) ? this._portaled : null;

        if (!portaled) {
          const owned = portaledDialog(this._injKey());
          if (owned) { owned.__waAdopted = true; portaled = this._portaled = owned; }
        }

        let inner = this.querySelector('dialog');
        if (portaled && inner && inner !== portaled) {
          inner.remove();
          inner = null;
        }
        const d = portaled || inner;
        this._dialog = d || null;
        if (d) this.wire(d);
        hideBrokenCards(d); // WA - masquage cartes produit vides
        return d;
      }

      wire(d) {
        if (d.__waWired) return;
        d.__waWired = true;
        const key = this._injKey();

        // Interaction dans CETTE popup (hors fermeture) : attribue le prochain ajout.
        const mark = (e) => {
          if (e.target === d || (e.target.closest && e.target.closest('[data-wa-close]'))) return;
          lastInteraction = { key: key, at: Date.now() };
        };
        d.addEventListener('pointerdown', mark, true);
        d.addEventListener('submit', mark, true);
        d.addEventListener('keydown', mark, true);

        // Fermeture : on retrouve toujours l'instance courante du bloc (le dialog
        // peut avoir été ré-adopté par une nouvelle instance après un remontage).
        const close = () => {
          const host = findHost(key);
          if (host) host.requestClose(); else closeOrphan(key);
        };
        d.querySelectorAll('[data-wa-close]').forEach((btn) => btn.addEventListener('click', close));
        d.addEventListener('click', (e) => { if (e.target === d) close(); });
        d.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
      }

      /* ------- Ouverture / fermeture ------- */
      open(d) {
        if (d.parentNode !== document.body) document.body.appendChild(d);
        d.setAttribute('data-wa-owner', this._injKey());
        d.__waClosing = false;
        d.classList.remove('dialog-closing');
        this._portaled = d;
        this._dialog = d;
        if (d.open) return;

        try {
          if (inEditor) {
            d.show();
          } else {
            d.removeAttribute('open');
            d.showModal();
          }
        } catch (e) {
          try { d.show(); } catch (e2) {}
        }
      }

      requestClose() {
        const d = this.resolveDialog();
        if (!d || !d.open || d.__waClosing) return;
        d.__waClosing = true;
        const key = this._injKey();

        d.classList.add('dialog-closing');
        const done = () => {
          if (!d.__waClosing) return;
          d.__waClosing = false;
          d.removeEventListener('animationend', done);
          d.classList.remove('dialog-closing');
          try { d.close(); } catch (e) {}
          const host = findHost(key);
          if (host && !host.querySelector('dialog')) host.appendChild(d); else d.remove();
          if (host) { host._portaled = null; host._dialog = host.querySelector('dialog'); }
          this._portaled = null;
          if (!inEditor) { syncLinksSoon(); onPopupClosed(key); }
        };
        d.addEventListener('animationend', done);
        setTimeout(done, 600);
      }
    });
  })();
  // WA:END - multi-popups v3.1 (contrôleur global renforcé)
  } catch(e) { console.error(e); }
})();

})();
